import { requestWithToken } from "../helper/helper";

export const fetchAllLanguages = async () => {
      const response = await requestWithToken(
        "GET",
        `/language/list`
      );  
      return response
  };